export const storeVDog = {
  state: {
    isGameInProgress: false,
    isAutoPlay: true,
    isVideoAllowed: true,
    isPauseAllowed: true
  },
  setGameInProgress (gameInProgress) {
    this.state.isGameInProgress = gameInProgress
  },
  isGameInProgress () {
    return this.state.isGameInProgress
  },
  setVideoAllowed (isVideoAllowed) {
    this.state.isVideoAllowed = isVideoAllowed ? true : isVideoAllowed
  },
  isVideoAllowed () {
    return this.state.isVideoAllowed
  },
  setAutoPlay (isAutoPlay) {
    this.state.isAutoPlay = isAutoPlay ? true : isAutoPlay
  },
  isAutoPlayEnabled () {
    return this.state.isAutoPlay
  },
  setPauseAllowed (isPauseAllowed) {
    this.state.isPauseAllowed = isPauseAllowed ? true : isPauseAllowed
  },
  isPauseAllowed () {
    return this.state.isPauseAllowed
  }
}
